import { Form, Input, Select, Radio } from "antd";
import { DeleteFilled } from "@ant-design/icons";
import React from "react";
import PhoneInput from "react-phone-number-input";

/**
 * Reusable component for additional phone details form
 * Used in leadCustomerInformationForm and PhoneFormJsx
 *
 * @param {Object} item - The phone item data
 * @param {Function} onDelete - Callback when delete is clicked
 * @param {number} index - Index of this phone in the list
 * @param {boolean} showPrimary - Whether to show the primary radio button
 * @param {string} primaryValue - The value for the radio button (should match Radio.Group value when selected)
 * @param {boolean} isPrimary - Whether this phone is currently the primary phone
 */
const AdditionalPhoneForm = ({
  item,
  index,
  onDelete,
  showPrimary = false,
  primaryValue,
  isPrimary = false,
}) => {
  return (
    <span className="w-full m-2 text-brand-500 items-center gap-1 bg-[#F8FAFC] p-2">
      <div className="flex-row-centered w-full justify-between">
        <span className="w-full text-sm font-[600] text-grey-700 ">
          Additional Phone Details #{index + 1}
          {isPrimary && <span className="ml-2 text-xs text-blue-600 font-medium">(Primary)</span>}
        </span>
        <span
          className="bg-[#F8FAFC] p-2 w-full text-sm font-[600] text-grey-700 text-right cursor-pointer"
          onClick={onDelete}
        >
          <DeleteFilled className="text-red-500 hover:text-red-700" />
        </span>
      </div>
      <div className="flex-row-centered w-full justify-between">
        <Form.Item
          label="Phone"
          name={`additional_phone_${index}`}
          className={showPrimary ? "w-[94%]" : "w-full"}
        >
          <PhoneInput
            className="lead-form-phone w-[90%] "
            placeholder="Enter phone number"
            name={`additional_phone_${index}`}
          />
        </Form.Item>
        {showPrimary && <Radio value={primaryValue} className="flex-shrink-0 self-start mt-9" />}
      </div>
      <div className="flex-row-centered w-full justify-between">
        <Form.Item
          label="Phone Type"
          name={`additional_phone_type_${index}`}
          className="bg-[#F8FAFC] w-full text-sm text-grey-700"
          rules={[{ required: true, message: "Phone type is required" }]}
        >
          <Select
            placeholder="Phone type"
            className="w-[90%]"
            maxTagCount="responsive"
            options={[
              { value: "Mobile", label: "Mobile" },
              { value: "Work", label: "Work" },
              { value: "Home", label: "Home" },
              { value: "Other", label: "Other" },
            ]}
          />
        </Form.Item>
        <Form.Item
          label="Relation"
          name={`additional_phone_relation_${index}`}
          className="w-[48%] bg-[#F8FAFC] w-full pl-4 text-sm text-grey-700 "
        >
          <Select
            placeholder="Relation"
            className="w-[90%]"
            maxTagCount="responsive"
            options={[
              { value: "Spouse", label: "Spouse" },
              { value: "Parent", label: "Parent" },
              { value: "Child", label: "Child" },
              { value: "Sibling", label: "Sibling" },
              { value: "Friend", label: "Friend" },
              { value: "Colleague", label: "Colleague" },
              { value: "Other", label: "Other" },
            ]}
          />
        </Form.Item>
      </div>
      <div className="flex-row-centered w-full justify-between">
        <Form.Item
          className="w-[48%]"
          name={`additional_phone_firstName_${index}`}
          rules={[{ required: true, message: "First name is required" }]}
          label="First Name"
        >
          <Input
            name={`additional_phone_firstName_${index}`}
            className="w-[95%]"
            placeholder="Enter first name"
          />
        </Form.Item>
        <Form.Item
          className="w-[48%]"
          name={`additional_phone_lastName_${index}`}
          rules={[{ required: true, message: "Last name is required" }]}
          label="Last Name"
        >
          <Input
            name={`additional_phone_lastName_${index}`}
            className="w-[90%]"
            placeholder="Enter last name"
          />
        </Form.Item>
      </div>
      <div className="flex-row-centered w-full justify-between">
        <Form.Item label="Note" name={`additional_phone_note_${index}`} className="w-full">
          <Input
            name={`additional_phone_note_${index}`}
            className="w-[95%]"
            placeholder="Enter note"
          />
        </Form.Item>
      </div>
    </span>
  );
};

export default AdditionalPhoneForm;
